import { render } from "./ListaFornitori.vue?vue&type=template&id=5814c4a1&scoped=true&ts=true"
import script from "./ListaFornitori.vue?vue&type=script&lang=ts"
export * from "./ListaFornitori.vue?vue&type=script&lang=ts"

import "./ListaFornitori.vue?vue&type=style&index=0&id=5814c4a1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5814c4a1"]])

export default __exports__